import { useEffect, useState } from "react";
import styles from "../styles.module.css";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import { ReactComponent as DuplicateIcon } from "../../../assets/icons/duplicate-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon.svg";
import { Popconfirm, Spin, Switch } from "antd";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import { useParams } from "react-router-dom";

const SurveyQuestionFooterActions = ({ comesFrom, question, questions }) => {
  const [loading, setLoading] = useState({
    newQuestion: false,
    duplicate: false,
    delete: false,
  });
  const {
    createNewQuestion,
    getSurveyInfo,
    deleteSurveyQuestion,
    duplicateSurveyQuestion,
    updateSurveyQuestion,
  } = useSurvey();
  const { id, pageId } = useParams();


  useEffect(() => {
    
  }, [questions])

  const handleCreateNewQuestion = async () => {
    setLoading((prev) => ({ ...prev, newQuestion: true }));
    const res = await createNewQuestion({
      id_survey: Number(id),
      id_page: Number(pageId),
      comes_from: comesFrom,
    });

    if (res) {
      await getSurveyInfo(Number(id));
    }
    setLoading((prev) => ({ ...prev, newQuestion: false }));
  };

  const handleQuestionAction = async (action) => {
    const functionToExecute = {
      delete: deleteSurveyQuestion,
      duplicate: duplicateSurveyQuestion,
    };

    setLoading((prev) => ({ ...prev, [action]: true }));
    const res = await functionToExecute[action](question.id);
    if (res) {
      await getSurveyInfo(Number(id));
    }
    setLoading((prev) => ({ ...prev, [action]: false }));
  };

  const updateSurveyQuestionHandler = async (values) => {
    const {
      questionsOptions,
      types_of_question,
      id_type_question,
      id: id_survey_question,
      ...cleanQuestion
    } = question;

    const data = {
      id_type_question: id_type_question.id,
      id_survey_question,
      conditional: values.conditional ?? question.addconditional,
      ...cleanQuestion,
      ...values,
    };

    const res = await updateSurveyQuestion(data);


    if (res) {
      await getSurveyInfo(Number(id));
    }
  };

  return (
    <footer className={styles["survey-question-footer-actions"]}>
      <button
        onClick={handleCreateNewQuestion}
        className={styles["add-question-btn"]}
        disabled={loading.newQuestion}
      >
        {loading.newQuestion ? <Spin /> : <PlusIcon />}
        <span>Añadir pregunta</span>
      </button>

      <div className={styles["question-actions-list"]}>
        <button
          onClick={() => {
            handleQuestionAction("duplicate");
          }}
        >
          {loading.duplicate ? <Spin /> : <DuplicateIcon />}
        </button>
        <Popconfirm
          title="¿Estas seguro de eliminar esta pregunta?"
          okButtonProps={{
            danger: true,
          }}
          onConfirm={async () => {
            await handleQuestionAction("delete");
          }}
        >
          <button>
            <DeleteIcon />
          </button>
        </Popconfirm>

        <div className={styles["question-action-switch"]}>
          <Switch
            defaultChecked={question.mandatory}
            onChange={(value) =>
              updateSurveyQuestionHandler({
                mandatory: value,
              })
            }
            size="small"
          />
          <span>Obligatoria</span>
        </div>

        {question.id_type_question.id !== 1 && (
          <>
            <div className={styles["question-action-switch"]}>
              <Switch
                defaultChecked={question.addconditional}
                onChange={(value) =>
                  updateSurveyQuestionHandler({
                    conditional: value,
                  })
                }
                size="small"
              />
              <span>Agregar condicional</span>
            </div>

            <div className={styles["question-action-switch"]}>
              <Switch
                defaultChecked={question.comments}
                onChange={(value) =>
                  updateSurveyQuestionHandler({
                    comments: value,
                  })
                }
                size="small"
              />
              <span>Comentario adicional</span>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default SurveyQuestionFooterActions;
